export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-900 mb-4 leading-tight">
            Obtenez Hipobuy Spreadsheet sur notre boutique
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-md mx-auto">
            Accédez à toutes les catégories mode et tableurs avancés sur kaspreadsheet.com
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              hipobuy spreadsheet
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-foreground-300/70 text-foreground-800 text-sm md:text-base font-semibold hover:border-primary-400 hover:text-primary-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Buy it Now
            </a>
          </div>
        </div>
      </div>

      <div className="mt-12 w-full overflow-hidden">
        <div className="flex gap-0">
          <div className="flex-shrink-0 w-1/5 h-36 md:h-48 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Designer%20high%20heel%20pumps%20on%20white%20pedestal%2C%20luxury%20product%20photography%2C%20clean%20studio%20lighting%2C%20minimal%20composition%2C%20cream%20background%2C%20fashion%20editorial%20style&width=400&height=384&seq=cta-v2-strip1&orientation=landscape"
              alt="Shoes"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="flex-shrink-0 w-1/5 h-36 md:h-48 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Knit%20sweater%20folded%20on%20marble%20surface%2C%20warm%20terracotta%20color%2C%20minimal%20product%20photography%2C%20soft%20studio%20lighting%2C%20textile%20texture%20detail&width=400&height=384&seq=cta-v2-strip2&orientation=landscape"
              alt="Sweater"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="flex-shrink-0 w-1/5 h-36 md:h-48 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Designer%20crossbody%20bag%20in%20cognac%20leather%20on%20white%20surface%2C%20luxury%20accessory%20photography%2C%20clean%20studio%20lighting%2C%20minimal%20composition&width=400&height=384&seq=cta-v2-strip3&orientation=landscape"
              alt="Bag"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="flex-shrink-0 w-1/5 h-36 md:h-48 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20wool%20blazer%20on%20wooden%20hanger%2C%20charcoal%20gray%2C%20minimal%20product%20photography%2C%20clean%20studio%20lighting%2C%20professional%20aesthetic&width=400&height=384&seq=cta-v2-strip4&orientation=landscape"
              alt="Blazer"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="flex-shrink-0 w-1/5 h-36 md:h-48 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Crystal%20fragrance%20bottle%20with%20rose%20gold%20cap%20on%20white%20pedestal%2C%20luxury%20perfume%20photography%2C%20clean%20studio%20lighting%2C%20minimal%20composition%2C%20elegant&width=400&height=384&seq=cta-v2-strip5&orientation=landscape"
              alt="Perfume"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}